import * as React from "react";
const SvgFiRrCommentExclamation = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-comment-exclamation_svg__a)">
      <path
        fill="#062147"
        d="M12 15a1 1 0 0 1-1-1V5a1 1 0 1 1 2 0v9a1 1 0 0 1-1 1m0 2a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 12 17m12 2v-6.66C24 5.861 19.096.454 12.836.028a12.04 12.04 0 0 0-9.327 3.493A12.02 12.02 0 0 0 .03 12.854C.47 19.208 6.082 24 13.084 24h5.917A5.005 5.005 0 0 0 24 19M12.701 2.024C17.916 2.378 22 6.909 22 12.339v6.66c0 1.654-1.346 3-3 3h-5.917c-6.035 0-10.686-3.904-11.059-9.284a10.02 10.02 0 0 1 2.899-7.781A10.02 10.02 0 0 1 12.7 2.023z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-comment-exclamation_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCommentExclamation;
